import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { Title } from 'components/layout'
import { Button } from 'components/misc'
import { Checkbox } from 'components/fields'
import { form } from 'helpers/decorators'

@form({
  form: 'participantUpdate',
  initialProps: 'data',
  initialPropsMapper: data => ({
    isEmailConfirmed: get(data, 'isEmailConfirmed')
  })
})
class AwardLeaderRegistrationEditModal extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func,
    handleSubmit: PropTypes.func,
    onAwardLeaderEdit: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    data: {}
  }

  render() {
    const { modalId, data, handleSubmit, onAwardLeaderEdit } = this.props

    return (
      <Modal id={modalId} customActions>
        <form
          onSubmit={handleSubmit(fields =>
            onAwardLeaderEdit(fields, get(data, 'id'))
          )}
        >
          <Title h2 intlKey="moduleTitle.award_leader_edit">
            Award Leader Edit
          </Title>

          <div className="row">
            <div className="col-xs-6">
              <Checkbox
                label="Email Confirmed"
                intlKey="label.email_confirmed"
                name="isEmailConfirmed"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <Button
                type="button"
                intlKey="button.close"
                secondary
                onClick={() => this.props.modal(null)}
              >
                Close
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button intlKey="button.save">Save</Button>
            </div>
          </div>
        </form>
      </Modal>
    )
  }
}

export default AwardLeaderRegistrationEditModal
